module.exports = __webpack_public_path__ + "media/images/navbar/ecran-b6f90e0ef56f721cad5f902f8d62ad84.png";